import { render, staticRenderFns } from "./orderChange.vue?vue&type=template&id=418f8c50&scoped=true"
import script from "./orderChange.vue?vue&type=script&lang=js"
export * from "./orderChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f8c50",
  null
  
)

export default component.exports